export default {
  contact: 1,
  prospect: 2,
  stageChange: 3,
  statusChange: 4,
  reminder: 5,
  note: 6,
};
